export default "__VITE_ASSET__CWAqzxHc__"